import Overlay from "../../components/overlays/DashboardOverlay";
import background from "../../images/placeholder-sito.png";

export default function StoreItem(props) {
  return (
    <article className="store-item">
      <div
        style={{
          backgroundColor: props.background,
          backgroundImage: `url(${background})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          height: "20vh",
          width: "100%",
        }}
      />
      <Overlay
        id={props.id}
        toggleModifyPopUp={props.toggleModifyPopUp}
        toggleDeletePopUp={props.toggleDeletePopUp}
        store={props.store}
        setEditingStore={props.setEditingStore}
        handleDuplicate={props.handleDuplicate}
      />
      <div className="caption">
        <h6>{props.nome}</h6>
        <p>Non Pubblicato</p>
      </div>
    </article>
  );
}
